import { getCookie } from 'cookies-next'

// tiktok cookie
export function getTiktokTtp() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('ttp')) ||
    getCookie('_ttp') ||
    null
  )
}
export function getTiktokTtclid() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('ttclid')) ||
    getCookie('ttclid') ||
    null
  )
}
